/**
 * Created by claudio iozzia on 29/06/2017.
 */
import {AcceptorOutputFn, andAcceptorSingle} from "../../../../models/acceptor/IAcceptor";
import {Utils} from "../../../../common/utils";
import {ISingleOutput} from "../../../../models/ISpec";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic} from "../../../../models/common";
import {acceptSingle_common_Vout} from "./dcdc__common_acceptor";
import {Acceptor_DcDc_BuckBoost} from "./dcdc_buck_boost_acceptor";
import {Acceptor_DcDc_798xBuckBoost} from "./dcdc_buck_boost_798x_acceptor";

export class Acceptor_DcDc_InvertingBuckBoost extends Acceptor_DcDc_798xBuckBoost {
  protected acceptSingle_Buck_Vout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {

    return  Utils.isValueEmpty(spec.spec.value.input.max)
       || Utils.isValueEmpty(out.voltage)
       || Math.abs(out.voltage) + spec.spec.value.input.max < ic.vout_max;
  }


}
